import { render, staticRenderFns } from "./binsFoldersMultiDropdown.vue?vue&type=template&id=0bb892a4&scoped=true"
import script from "./binsFoldersMultiDropdown.vue?vue&type=script&lang=js"
export * from "./binsFoldersMultiDropdown.vue?vue&type=script&lang=js"
import style0 from "./binsFoldersMultiDropdown.vue?vue&type=style&index=0&id=0bb892a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb892a4",
  null
  
)

export default component.exports